<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<section style="{style(block)}">
  <div class="container">
    <div class="row text-center justify-content-center">
      <div class="col-lg-8">
        <h3 class="mt-4">
          <span class="">{text(block, 'firstLine')}</span>
          <br><span>{text(block, 'secondLine')}</span>
        </h3>
        <p class="lead">{@html richtext(block, 'body')}</p>
      </div>
    </div>
  </div>
</section>
